import styled from "styled-components";
import photo1 from "assets/images/equilibrio-01.jpg";
import photo2 from "assets/images/equilibrio-02.jpg";
import photo3 from "assets/images/equilibrio-03.jpg";
import photo4 from "assets/images/equilibrio-04.jpg";
import photo5 from "assets/images/equilibrio-05.jpg";
import { fonts } from "styles";

export const Container = styled.section`
  width: 100%;
  flex-shrink: 0;
  flex-grow: 0;
  height: 100vh;
  display: flex;
  background-color: white;

  @media screen and (max-width: 1010px) {
    flex-direction: column;
    flex-shrink: unset;
    flex-grow: unset;
    height: 100%;
  }
`;

export const Content = styled.div`
  flex-shrink: 0;
  flex-grow: 0;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 96px 295px 96px 900px;
  position: relative;
  background-color: #090909;

  @media screen and (max-width: 1010px) {
    flex-direction: column;
    height: auto;
    padding: 260px 40px 40px 40px;
  }

  @media screen and (max-width: 414px) {
    padding-top: 310px;
  }

  @media screen and (max-width: 375px) {
    padding-top: 210px;
  }
`;

export const FirstPhotosWrapper = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  grid-column-gap: 12px;
  align-items: center;
  position: absolute;
  left: -207px;

  @media screen and (max-width: 1010px) {
    grid-template-columns: unset;
    grid-column-gap: unset;
    grid-row-gap: 4px;
    left: unset;
    top: -780px;
    padding: 0 40px;
    width: 100%;
  }

  @media screen and (max-width: 414px) {
    top: -530px;
  }
`;

export const LastPhotosWrapper = styled.div`
  display: grid;
  grid-template-columns: auto auto auto;
  grid-column-gap: 12px;
  align-items: center;
  position: relative;
  margin-right: 192px;

  @media screen and (max-width: 1010px) {
    grid-template-columns: unset;
    grid-column-gap: unset;
    grid-row-gap: 4px;
    margin-right: 0;
    margin-top: 82px;
    margin-bottom: 56px;
  }
`;

export const Photo1 = styled.img.attrs({ src: photo1 })`
  object-fit: contain;

  @media screen and (max-width: 1010px) {
    width: 100%;
    height: auto;
  }
`;

export const Photo2 = styled.img.attrs({ src: photo2 })`
  object-fit: contain;

  @media screen and (max-width: 1010px) {
    width: 100%;
    height: auto;
  }
`;

export const Photo3 = styled.img.attrs({ src: photo3 })`
  object-fit: contain;

  @media screen and (max-width: 1010px) {
    width: 100%;
    height: auto;
  }
`;

export const Photo4 = styled.img.attrs({ src: photo4 })`
  object-fit: contain;

  @media screen and (max-width: 1010px) {
    width: 100%;
    height: auto;
  }
`;

export const Photo5 = styled.img.attrs({ src: photo5 })`
  object-fit: contain;

  @media screen and (max-width: 1010px) {
    width: 100%;
    height: auto;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  height: 602px;

  &.last {
    justify-content: center;
  }

  @media screen and (max-width: 1010px) {
    height: auto;
  }

  @media screen and (max-width: 414px) {
    width: 100%;
  }
`;

export const TextWrapper = styled.div`
  display: grid;
  grid-template-columns: 288px 318px;
  grid-column-gap: 72px;
  align-self: center;
  margin-right: 88px;
  align-items: flex-start;

  @media screen and (max-width: 1010px) {
    grid-template-columns: unset;
    grid-column-gap: unset;
    grid-row-gap: 24px;
    margin-right: 0;
  }
`;

export const OneColumn = styled.div`
  display: grid;
  grid-template-columns: 279px;
  grid-column-gap: 72px;
  align-self: center;
  margin-right: 88px;
  align-items: flex-start;

  @media screen and (max-width: 1010px) {
    grid-template-columns: unset;
    grid-column-gap: unset;
    grid-row-gap: 24px;
    margin-right: 0;
  }
`;

export const Title = styled.h2`
  font-family: ${fonts.BentonSansWideMedium};
  font-size: 28px;
  line-height: 32px;
  margin-bottom: 72px;
  color: white;

  @media screen and (max-width: 1010px) {
    margin-bottom: 32px;
  }
`;

export const Text = styled.article`
  width: 100%;
  font-size: 15px;
  line-height: 22px;
  color: white;

  span {
    font-family: ${fonts.BentonSansRegular};
  }

  &.light {
    font-family: ${fonts.BentonSansLight};
  }

  &.black {
    color: black;
    a {
      color: black;
    }
  }

  p {
    margin-bottom: 24px;

    a {
      text-decoration: underline;
      color: white;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export const Credit = styled.span`
  font-size: 15px;
  line-height: 22px;
  display: block;
  position: absolute;
  bottom: -32px;
  left: 0;
  color: white;

  @media screen and (max-width: 1010px) {
    bottom: unset;
    left: 40px;
    top: -32px;
    font-size: 12px;

    &.last {
      left: 0;
    }
  }
`;
